/* =================== SERVIÇOS HOME =================== */
$(function () {
  $(".carrosel-servicos").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 760,
        settings: "unslick",
      },
    ],
  });
});

(function () {
  "use strict";

  // Slide
  $(".anuncio-det-slide").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    dots: false,
    autoplay: false,
    //autoplaySpeed: 5000,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }, {
      breakpoint: 760,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  $(".anuncio-det-slide-wrp").css("height", "auto");
  $(".anuncio-det-slide").css("opacity", "1");

  // Exibe a Ã¢ncora fixa (MOBILE)
  if (isMobileX(1199) && $("#reserva-mobile-sec").length > 0) {
    $(window).on("scroll", debounce(function () {
      var offset = $("#reserva-mobile-sec").offset().top + $("#reserva-mobile-sec").outerHeight() - $(".header-full").outerHeight();
      if ($(window).scrollTop() > offset) {
        $(".anuncio-det-anchor").addClass("active");
      } else {
        $(".anuncio-det-anchor").removeClass("active");
      }
    }, 50));
  }
})();